const RESET_TO_DEFAULT_COLOR = '\x1b[0m';
const BE_COLOR_BASE = '\x1b[3';
const COLOUR_OPTIONS = ['0', '1', '2', '3', '4', '5', '6', '7', '8'];
const BE_COLOR_END = 'm';
export const consoleLogSink = (event) => {
    console[event.level](wrapInColor(event.name), event.msg, ...event.args, event.data);
};
function wrapInColor(name) {
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = (hash << 5) - hash + name.charCodeAt(i);
        hash |= 0;
    }
    return `${BE_COLOR_BASE}${COLOUR_OPTIONS[Math.abs(hash) % COLOUR_OPTIONS.length]}${BE_COLOR_END}${name}${RESET_TO_DEFAULT_COLOR}`;
}
//# sourceMappingURL=consoleLogSink.js.map